import { render, staticRenderFns } from "./PromotionContent.vue?vue&type=template&id=47d36dfa"
import script from "./PromotionContent.vue?vue&type=script&lang=js"
export * from "./PromotionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme2DesktopPromotionCard: require('/app/components/Theme2/Desktop/PromotionCard.vue').default})
